export default __webpack_public_path__ + "static/media/pp4.5dee5b1c.png";